import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'
import CourseDocumentsContent from './CourseDocumentsContent'

export default class CourseDocuments extends Component {

    render() {
        
        let page = this.props.match.params.page;
        let courseId = this.props.match.params.courseId;
        const urlParams = new URLSearchParams(window.location.search);

        return (
            <div className="wrapper">
                <Navbar />
                <Mainmenu />
                <CourseDocumentsContent urlParams={urlParams} page={page} courseId={courseId} />
                <Footer />

            </div>


        )
    }
}
